import { RoomFindDto, type RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CctvDtoKeysEnum } from '@zaoblako/shared/modules/cctv/enums/cctv-dto-keys.enum';

import * as yup from 'yup';

/** Car parking price for room response body - DTO signature */
export interface CarCategoryRoomPriceFindInterface {
  /** Related room */
  room: RoomFindInterface;
  /** Price for hour */
  price: number;
}

/** Car parking price for room response body - DTO schema */
export const CarCategoryRoomPriceFindDto = SerdeDtoClass.create<CarCategoryRoomPriceFindInterface>(CctvDtoKeysEnum.CAR_CATEGORY_ROOM_PRICE_FIND_DTO, {
  room: {
    label: 'Помещение',
    nested: RoomFindDto,
    serializer: (_, nested) => nested,
  },
  price: {
    label: 'Цена за час',
    serializer: yup.number(),
  },
});
